export * from './lpr.component';
